import { Component, OnInit, HostListener, Input } from '@angular/core';
import { AuthService } from 'src/app/api/auth.service';
import { ProfileService } from 'src/app/api/profile.service';
import { User } from 'src/app/models/user';
import { environment } from 'src/environments/environment';
import { ThemeService } from 'src/app/services/theme.service';
import { LocaleService } from 'src/app/services/locale.service';
import { VerificationStatus, VerificationStatusService } from 'src/app/services/verification-status.service';

@Component({
    selector: 'site-header',
    templateUrl: './site-header.component.html',
    styleUrls: ['./site-header.component.scss'],
    standalone: false
})
export class SiteHeaderComponent implements OnInit {
  @Input() logo = 'assets/images/logo-white.svg';

  links = environment.links;
  menuOpened = false;
  user!: User;
  sticky = false;
  isArabic = false;
  isDarkMode = false;
  verification: VerificationStatus = {
    isIndividualVerificationEnabled: false,
    status: null,
  };

  readonly campaignHubUrl = `${environment.links.blog}campaign-hub`;

  constructor(
    private auth: AuthService,
    private profileService: ProfileService,
    private localeService: LocaleService,
    private themeService: ThemeService,
    private verificationStatusService: VerificationStatusService,
  ) {}

  ngOnInit() {
    this.isArabic = this.localeService.isArabic();
    this.isDarkMode = this.themeService.isDarkTheme;
    this.getProfile();
    this.loadVerificationStatus();
  }

  getProfile() {
    if (this.isLoggedIn()) {
      this.profileService.getGeneral().subscribe(data => {
        this.user = data;
      });
    }
  }

  loadVerificationStatus() {
    if (this.isLoggedIn()) {
      this.verificationStatusService.loadStatus().subscribe((verification) => {
        this.verification = verification;
      });
    }
  }

  toggleMenu() {
    this.menuOpened = !this.menuOpened;

    if (this.menuOpened) {
      window.document.body.classList.add('noscroll');
    } else {
      window.document.body.classList.remove('noscroll');
    }
  }

  isLoggedIn() {
    return this.auth.getToken();
  }

  isVerified() {
    return VerificationStatusService.computeIsVerified(this.verification, this.user);
  }

  getArLink() {
    return window.location.href.replace('/en/', '/ar/');
  }

  getEnLink() {
    return window.location.href.replace('/ar/', '/en/');
  }

  @HostListener('window:scroll')
  onScroll() {
    if (window.scrollY > 100) {
      this.sticky = true;
    } else {
      this.sticky = false;
    }
  }
}
